import React from 'react'
import { Tooltip } from 'antd'

const ColoredTooltip = ({ title, coloredTitle, color, children, ...props }) => (
  <Tooltip
    title={
      coloredTitle ? (
        <span>
          {title} <span style={{ color, fontWeight: 600 }}>{coloredTitle}</span>
        </span>
      ) : (
        <span style={{ fontWeight: 600 }}>{title}</span>
      )
    }
    {...props}
  >
    {children}
  </Tooltip>
)

export default ColoredTooltip
